import React, { useMemo } from "react";
import { type ProcessedPackage } from "./processedCatalog";
import { buildProductSheet, type SheetProduct } from "./processedProductSheet";
import ProductSheetDialog from "./ProductSheetDialog";
import { processedProductArchiveImages, type ProductExportFormat } from "./productArchive";

export default function ProcessedProductSheetDialog({ product, packages, dataReady, onClose, format }: {
  product?: SheetProduct; packages: ProcessedPackage[]; dataReady: boolean; onClose: () => void; format?: ProductExportFormat;
}) {
  const sheets = useMemo(() => product ? {
    sv: buildProductSheet(product, packages, "sv"), en: buildProductSheet(product, packages, "en"),
  } : undefined, [product, packages]);
  const images = useMemo(() => product ? processedProductArchiveImages(product) : [], [product]);
  return <ProductSheetDialog sheets={sheets} dataReady={dataReady} onClose={onClose} format={format} archiveImages={images} />;
}
